import { render, staticRenderFns } from "./studenttotalscore.vue?vue&type=template&id=8525eae8&scoped=true"
import script from "./studenttotalscore.vue?vue&type=script&lang=js"
export * from "./studenttotalscore.vue?vue&type=script&lang=js"
import style0 from "./studenttotalscore.vue?vue&type=style&index=0&id=8525eae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8525eae8",
  null
  
)

export default component.exports